import '../base';
import '../components/carousels/featured-products';
